// Copyright (c) 2017 Deere & Company

import {
    addFile,
    updateAverageTechPayRate,
    updateComments,
    updateEffectiveDate,
    updateIsSubmitDisabled,
    updateRequestedRate
} from './labor-rate';
import {deleteFile} from './delete-file';
import {postLaborRateChange} from './post-labor-rate';
import {readLaborRates} from './get-labor-rates';
import {updateConfirmationModalVisibility} from './confirmation-modal';

export default {
    addFile,
    deleteFile,
    postLaborRateChange,
    readLaborRates,
    updateAverageTechPayRate,
    updateComments,
    updateConfirmationModalVisibility,
    updateEffectiveDate,
    updateIsSubmitDisabled,
    updateRequestedRate
};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/action-creators/index.js